import { paths } from '@/config/paths';

import type { OrganizationInvite, OrganizationMember } from '../types';

export const SUPPORT_EMAIL = 'support@beyondpresence.ai';

const ROLE_LABELS: Record<string, string> = {
  owner: 'Primary owner',
  admin: 'Admin',
  member: 'User',
};

export const DEFAULT_ROLE_LABEL = 'User';

export const getRoleLabel = (role?: string | null): string => {
  if (!role) return DEFAULT_ROLE_LABEL;
  return ROLE_LABELS[role] ?? DEFAULT_ROLE_LABEL;
};

export const isOwner = (member: OrganizationMember): boolean =>
  member.role === 'owner';

export const getInviteUrl = (inviteId: string): string =>
  `${window.location.origin}${paths.app.invite.getHref(inviteId)}`;

export const isPendingInvite = (invite: OrganizationInvite): boolean =>
  invite.outcome === null && new Date(invite.expires_at).getTime() > Date.now();
